import { TableHeaderCategoryConfig } from "../../../../../components/tables/tableContext/TableContext";
import { NodeBinsListInterface } from "../../../../../redux/interfaces/expedition.interface";

export const viewCargoVolumeTableHeader: TableHeaderCategoryConfig[] = [
  {
    value: "Id bin",
    minW: 125,
  },
  {
    value: "Volum",
    minW: 125,
  },
  {
    value: "SN BIN/COLET",
    minW: 125,
  },
];

export const getViewCargoVolumeTableData: any = (
  data: NodeBinsListInterface[],
) =>
  data?.map((item) => {
    return {
      id: item.id_bin,
      crudData: item,
      data: [
        {
          title: item.id_bin,
        },
        {
          badges: [
            {
              badgeText: item.nrColeteVolumScanat,
              badgeColor: "light-success",
            },
            {
              badgeText: item.nrColeteVolum,
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.sn_bin,
              badgeColor: "light-success",
            },
            {
              badgeText: item.sn_colet,
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
